import React from "react";
import { CondimentWrapperStyled } from "./CondimentWrapperStyled";
import { CondimentWrapperProps } from "../../../entities/Condiment";
import CondimentCard from "../CondimentCard";
import Typography from "../../../UI/Typography/Typography";
import { TYPOGRAPHY_TYPE } from "../../../entities/Typography";
import { VIEW_TYPE } from "../../../entities/Filter";
import { TEST_ID } from "../../../shared/testid";

const CondimentWrapper: React.FC<CondimentWrapperProps> = ({
  title,
  condiments = [],
  onSelect,
  view = VIEW_TYPE.GRID,
  isCategoriesCondiments = false,
  disableSelected = true,
}: CondimentWrapperProps) => {
  return (
    <CondimentWrapperStyled>
      <div className="condiment-wrapper__title">
        <Typography type={TYPOGRAPHY_TYPE.TITLE_FIVE}>{title}</Typography>
      </div>
      <div
        className={`condiment-wrapper__items view-${view}`}
        data-length={condiments.length}
        data-testid={TEST_ID.CONDIMENT.WRAPPER}
      >
        {condiments.map((condiment) => (
          <CondimentCard
            onSelect={onSelect}
            key={condiment.id}
            condiment={condiment}
            view={view}
            isCategoriesCondiments={isCategoriesCondiments}
            disableSelected={disableSelected}
          />
        ))}
      </div>
    </CondimentWrapperStyled>
  )
};

export default CondimentWrapper;
